<template>
  <div class="wrapper">
    <v-top></v-top>
    <v-sidebar></v-sidebar>
    <!-- <v-foot></v-foot> -->
    <div class="content-box" id="content-box">
        <el-scrollbar>
            <div style="height: 100%; margin-right:20px;">
                <!-- 此处放置el-tabs代码 -->
                <div class="page-tabs">
                    <el-tabs 
                        v-model="activeIndex"
                        type="card" closable
                        v-if="openTab.length"
                        @tab-click='tabClick'
                        @tab-remove='tabRemove'
                    >
                        <el-tab-pane
                            :key="item.name"
                            v-for="item in openTab"
                            :label="item.name"
                            :name="item.route"
                        >
                        </el-tab-pane>
                    </el-tabs>
                </div>
                <keep-alive :include="keepAlive">
                    <router-view />
                </keep-alive>
            </div>
        </el-scrollbar>
    </div>
  </div>
</template>

<script>
import vTop from '@/components/common/Header.vue';
import vSidebar from '@/components/common/Sidebar.vue';
import vFoot from '@/components/common/Footer.vue';
export default {
    name: 'home',
    components: {
        vTop,
        vSidebar,
        vFoot
    },
    watch:{
        '$route'(to,from){
            //判断路由是否已经打开
            //已经打开的 ，将其置为active
            //未打开的，将其放入队列里
            let flag = false;
            for(let item of this.openTab){
                if(item.name === to.name){
                    this.$store.commit('set_active_index',to.path)
                    flag = true;
                    break;
                }
            }

            if(!flag){
                this.$store.dispatch('set_tabs', {route: to.path, name: to.name});
                this.$store.commit('set_active_index', to.path);
            }
        }
    },
    mounted () {
        var historytab = JSON.parse(sessionStorage.getItem('GETONETAB'))
        if(!(historytab)){
            this.$store.dispatch('set_tabs', {route: this.$route.path , name: this.$route.name });
        }
        else{
            this.$store.commit('add_tabs',historytab);
        }     
        this.$store.commit('set_active_index', this.$route.path);
    },
    computed: {
        openTab () {
            return this.$store.state.openTab;
        },
        keepAlive(){
            let arr=[];
            this.$store.state.openTab.map(val => {
                arr.push(val.route.substr(1))
            });
            return arr;
        },
        activeIndex:{
            get () {
                return this.$store.state.activeIndex;
            },
            set (val) {
                this.$store.commit('set_active_index', val);
            }
        }
    },
    methods:{
        //tab标签点击时，切换相应的路由
        tabClick(tab){
            console.log(this.$store.state.openTab)
            this.$router.push({path: this.activeIndex});
        },
        //移除tab标签
        tabRemove(targetName){
            //首页 或者 只有一个 不删
            if(targetName == '/' || this.openTab.length==1){
                return
            }
            this.$store.commit('delete_tabs', targetName);
            if (this.activeIndex === targetName) {
                // 设置当前激活的路由
                if (this.openTab && this.openTab.length >= 1) {
                    this.$store.commit('set_active_index', this.openTab[this.openTab.length-1].route);
                    this.$router.push({path: this.activeIndex});
                } else {
                    // this.$router.push({path: '/'});
                }
            }
        }
    }
}
</script>
<style lang="less" scoped>
.content-box{
	position: absolute;
	left: 210px;
	right: 0px;
	top: 60px;
	bottom: 10px;
	transition: left .3s ease-in-out;
	/deep/.el-scrollbar {
		height: 100%;
		.el-scrollbar__wrap {
			overflow-x: hidden;
		}
		.el-scrollbar__view {
			height: 100%;
		}
	}
	.breadcrumb{
		background-color: #EDF0F7;
		padding: 10px 0 10px 30px;
		width: 100%;
		margin-left: -20px;
		margin-top: -10px;
		margin-bottom: 10px;
	}
}
#content-box .el-table{
	font-size: 12px ;
	color: #606266;
}
.mini-navbar .content-box {
	left:86px;
}
</style>
